import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState } from "react"
import Logo from "../../assets/images/rema.png"

import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// actions
import { loginUser, apiError } from "../../store/actions"

// import images
import logoSm from "../../assets/images/logo-sm.png"
import Footer from "./Footer"

import Authentication from "services/Authentication.service"
const authService = new Authentication()
const Login = props => {
  const [error, setError] = useState("")
  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    authService
      .login({ username: values.username, password: values.password })
      .then(response => {
        if (response.status) {
          setError("")
          localStorage.setItem(
            "authUser",
            JSON.stringify({
              ...response.data,
            })
          )
          props.history.push("/dashboard")
        } else {
          setError(response.message)
        }
      })
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Login | REMA</title>
      </MetaTags>
      <div
        className="container  justify-content-center d-flex flex-column tw-right-0 tw-left-0 py-5">
        <div className="row pt-5 justify-content-center">
          <div className="col-md-8 col-lg-8  col-xxl-5">
            <div className="card  rounded-4 shadow-md">
              <div className="card-body">
                <div className="d-flex mb-3 justify-content-center">
                  <div
                    className="tw-h-24 d-flex justify-content-center align-items-center tw-w-24 border border-warning border-3 shadow-sm rounded-circle" style={{width:'6rem',height:'6rem'}}>
                    <img src={Logo} alt="Rema Logo" className="img-fluid"/>
                  </div>
                </div>
                <h5 className="fw-semibold  text-center">Welcome to REMA Licensing</h5>
                <p className="text-center text-muted tw-text-xs">Sign in to continue to
                  access your portal.</p>
                <div className="p-3">
                  <AvForm
                    className="form-horizontal mt-4"
                    onValidSubmit={(e, v) => {
                      handleValidSubmit(e, v)
                    }}
                  >
                    {error && typeof error === "string" ? (
                      <Alert color="danger">{error}</Alert>
                    ) : null}

                    <div className="mb-3">
                      <AvField
                        name="username"
                        label="Email/Phone"
                        //value="admin@themesbrand.com"
                        className="form-control"
                        placeholder="Enter email/phone number"
                        type="text"
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <AvField
                        name="password"
                        label="Password"
                        //value=""
                        type="password"
                        required
                        placeholder="Enter Password"
                      />
                    </div>

                    <Row className="mb-3 align-items-center">
                      <Col sm={6}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customControlInline"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="customControlInline"
                          >
                            Remember me
                          </label>
                        </div>
                      </Col>
                      <Col sm={6} className="text-end">

                        <div className=" ">
                          <a href="/forgot-password" className="text-decoration-none text-black">Forgot
                            password?</a>
                        </div>
                      </Col>
                    </Row>
                    <button
                      className="btn btn-primary w-100 py-2 waves-effect waves-light"
                      type="submit"
                    >
                      Log In
                    </button>
                  </AvForm>

                </div>

                <div className="text-center mb-3">
                  Don't have an
                  account?
                  <a href="/register" className="text-decoration-none"> Register</a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login)
)

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
}
